module.exports = __webpack_public_path__ + "Bliss2-BoldItalic.25becc080767c2b60696.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-BoldItalic.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2-BoldItalic.woff
// module chunks = styles